import React from "react";

import { SearchInput } from "../../encounters/components/search-input";
import { PaymentStatusFilters } from "./filters/payment-status-filters";
// import { PaymentDateFilters } from "./filters/payment-date-filters";

interface PaymentFiltersProps {
    searchValue: string;
    setSearchValue: (value: string) => void;
    date: string;
    setDate: React.Dispatch<React.SetStateAction<string>>;
    status: string;
    setStatus: React.Dispatch<React.SetStateAction<string>>;
}

export const PaymentFilters = ({ 
    searchValue, 
    setSearchValue, 
    // setDate, 
    // date, 
    status, 
    setStatus 
}: PaymentFiltersProps) => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between w-full mt-[16px] gap-[16px] h-fit">
            <SearchInput
                value={searchValue}
                setValue={setSearchValue}
                placeholder="Search by patient name or email"
                className=""
            />

            <div className="flex flex-row items-center gap-[16px] justify-start md:justify-end w-full md:w-auto h-fit">
                <PaymentStatusFilters status={status} setStatus={setStatus} />
                {/* <PaymentDateFilters date={date} setDate={setDate} /> */}
            </div>
        </div>
    );
}; 